module.exports = __webpack_public_path__ + "img/x_icon.37ca9b07.svg";